import React, { createContext, useCallback, useContext, useState } from "react";
import { useAuth } from "./AuthContext";
import { useTeamRecord } from "./useTeamRecord";

const TeamContext = createContext();
export const useTeam = () => useContext(TeamContext);

export const TeamProvider = ({ children, initialTeamId = null, selectedTeamId = undefined }) => {
  const { userData, loading: authLoading, error: authError, refreshAuth } = useAuth();
  const persistedTeamId = userData?.activeTeamId ?? userData?.pendingActiveTeamId ?? userData?.teamId ?? null;
  // Explicit selections remain scoped to the account and the persisted selection
  // they replaced. A subsequent profile update wins over an old selection.
  const source = JSON.stringify([userData?.uid, persistedTeamId, initialTeamId]);
  const [selection, setSelection] = useState(null);
  const teamId = !userData?.uid ? null : selectedTeamId !== undefined ? selectedTeamId : selection?.source === source
    ? selection.teamId : persistedTeamId || initialTeamId || null;
  const record = useTeamRecord(userData?.uid, teamId);
  const setTeamId = useCallback((next) => setSelection({
    source, teamId: typeof next === "function" ? next(teamId) : next,
  }), [source, teamId]);

  return (
    <TeamContext.Provider value={{
      teamId, setTeamId,
      teamName: record.team?.name || record.team?.teamName || record.team?.title || null,
      username: userData?.username || userData?.email || null,
      loading: authLoading || record.loading,
      error: authError || record.error,
      isActiveTeamMember: record.isActiveTeamMember,
      refreshTeam: authError ? refreshAuth : record.refreshTeam,
    }}>
      {children}
    </TeamContext.Provider>
  );
};
